import React from "react";
import round from "lodash/round";
import get from "lodash/get";
import fromIntensity from "../../../../utils/get-zone";

import WeekTitlesComponent from "./WeekTitlesComponent";
import WeekParamtersComponent from "./WeekParametersComponent";
import ActualResultsComponent from "./ActualResultsComponent";
import { getExerciseName } from "../../../../parts/modals/learn-more/blockHelpers";

const ExerciseLineItemCalendar = ({
  isWeekView,
  withWeight,
  units,
  fromMetric,
  isAssistant,
  defaultRepMax,
  set,
  idx,
  exercise,
  prefix,
  isAnySetCompleted,
  expanded,
  toggleExpanded,
  intensityMeasure,
  isRiR,
  hideVelocitySettings,
}) => {
  const percentRM = round((get(set, "load", 0) / defaultRepMax) * 100, 1);

  const precision = units === "metric" ? 2 : 1;
  const load = set.load
    ? withWeight(round(fromMetric(set.load, units), precision), units)
    : "";
  const exerciseName = getExerciseName(exercise);

  const hasLoad = Boolean(load);
  const currentZone = fromIntensity(set.percentRepMax, set.reps);
  const isAmrap = set.rpe === "AMRAP" && !set.reps;

  if (isAnySetCompleted) {
    return (
      <ActualResultsComponent
        exercise={exercise}
        set={set}
        percentRM={percentRM}
        units={units}
        withWeight={withWeight}
        fromMetric={fromMetric}
        idx={idx}
        load={load}
        exerciseName={exerciseName}
        prefix={prefix}
        expanded={expanded}
        toggleExpanded={toggleExpanded}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
        hideVelocitySettings={hideVelocitySettings}
      />
    );
  }

  return (
    <>
      {idx === 0 && (
        <>
          <div className="name-wrapper">
            {isWeekView && <span className="calendar-prefix">{prefix}</span>}
            <p className="font-semibold">{exerciseName}</p>
          </div>
          <WeekTitlesComponent
            exercise={exercise}
            intensityMeasure={intensityMeasure}
            isRiR={isRiR}
          />
        </>
      )}

      <WeekParamtersComponent
        exercise={exercise}
        set={set}
        isAmrap={isAmrap}
        percentRM={percentRM}
        hasLoad={hasLoad}
        load={load}
        isAssistant={isAssistant}
        currentZone={currentZone}
        withWeight={withWeight}
        units={units}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
      />
    </>
  );
};

export default ExerciseLineItemCalendar;
